/**
 * Created by chenguangjun on 2016/9/29.
 */

import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    { // Main
      path:   '/',
      name:   'main',
      component:  () => import('../views/main.vue')
    },
    { // 登录
      path:   '/login',
      name:   'login',
      component:  () => import('../views/login.vue')
    },
    { // 修改密码
      path:   '/editPassword',
      name:   'editPassword',
      component:  () => import('../views/editPassword.vue')
    },
    { // 日志操作
      path:   '/log',
      name:   'log',
      component:  () => import('../views/log.vue')
    },
    { // 员工管理
      path:   '/admin',
      name:   'admin',
      component:  () => import('../views/admin')
    },

    { // 敏感词管理
      path:   '/sensitive',
      name:   'sensitive',
      component:  () => import('../views/sensitive')
    },
    { // 部门管理
      path:   '/sysDept',
      name:   'sysDept',
      component:  () => import('../views/sysDept')
    },
    { // 添加部门
      path:   '/createSysDept',
      name:   'createSysDept',
      component:  () => import('../views/createSysDept')
    },
    { // 角色管理
      path:   '/sysRole',
      name:   'sysRole',
      component:  () => import('../views/sysRole')
    },
    { // 添加角色
      path:   '/createSysRole',
      name:   'createSysRole',
      component:  () => import('../views/createSysRole')
    },
    { // 会员管理
      path:   '/member',
      name:   'member',
      component:  () => import('../views/member')
    },
    { // 会员管理
      path:   '/member/:tab',
      component:  () => import('../views/member')
    },
    { // 添加主会员
      path:   '/createMaster',
      name:   'createMaster',
      component:  () => import('../views/createMaster')
    },
    { // 主会员文件管理
      path:   '/masterFileMan',
      name:   'masterFileMan',
      component:  () => import('../views/masterFileMan')
    },
    { // 会员审批
      path:   '/memberCert',
      name:   'memberCert',
      component:  () => import('../views/memberCert')
    },

    { // 门禁管理
      path:   '/entranceGuard',
      name:   'entranceGuard',
      component:  () => import('../views/entranceGuard')
    },
    { // 门禁管理
      path:   '/entranceGuard/:tab',
      component:  () => import('../views/entranceGuard')
    },
    { // 访客管理
      path:   '/visitor',
      name:   'visitor',
      component:  () => import('../views/visitor/visitor')
    },
    { // 卡片管理
      path:   '/card',
      name:   'card',
      component:  () => import('../views/card')
    },
    { // 卡片管理
      path:   '/card/:tab',
      component:  () => import('../views/card')
    },
    { // 广场卡片审核
      path:   '/squareCard',
      name:   'squareCard',
      component:  () => import('../views/squareCard')
    },

    { // 举报管理
      path:   '/cardReport',
      name:   'cardReport',
      component:  () => import('../views/cardReport')
    },
    { // 广告管理
      path:   '/Ad',
      name:   'Ad',
      component:  () => import('../views/ad')
    },
    { // 广告管理
      path:   '/ad',
      name:   'ad',
      component:  () => import('../views/ad')
    },

    { // 我的社区
      path:   '/myCommunity',
      name:   'myCommunity',
      component:  () => import('../views/myCommunity')
    },
    { // 个人资料
      path:   '/myInfo',
      name:   'myInfo',
      component:  () => import('../views/myInfo')
    },
    { // 二维码管理
      path:   '/qr',
      name:   'qr',
      component:  () => import('../views/qr')
    },

    { // 社区管理
      path:   '/community',
      name:   'community',
      component:  () => import('../views/community')
    },
    { // 添加社区
      path:   '/createCommunity',
      name:   'createCommunity',
      component:  () => import('../views/createCommunity')
    },
    { // 添加主题社区
      path:   '/createCommunity-theme',
      name:   'createCommunity-theme',
      component:  () => import('../views/createCommunity-theme')
    },

    { // 公告信息管理
      path:   '/notification',
      name:   'notification',
      component:  () => import('../views/notification')
    },

    { // 系统公告管理
      path:   '/sysNotice',
      name:   'sysNotice',
      component:  () => import('../views/sysNotice')
    },

    { // 社区服务信息管理
      path:   '/communityService',
      name:   'communityService',
      component:  () => import('../views/communityService')
    },

    { // 操作手册内容管理
      path:   '/guideContent',
      name:   'guideContent',
      component:  () => import('../views/guide/content.vue')
    },

    { // 操作手册内容查看
      path:   '/guidePreview',
      name:   'guidePreview',
      meta: {
        withOutMenu: true
      },
      component:  () => import('../views/guide/preview.vue')
    },

    // 送水
    { // 送水
      path:   '/water',
      name:   'water',
      component:  () => import('../views/water')
    },

    // 报修
    { // 意见报修
      path:   '/repair',
      name:   'repair',
      component:  () => import('../views/repair')
    },
    { // 意见报修
      path:   '/repair/:tab',
      component:  () => import('../views/repair')
    },

    // 场地
    { // 场地预约
      path:   '/venue',
      name:   'venue',
      component:  () => import('../views/venue/venue')
    },

    // 缴费
    { // 物业缴费
      path:   '/payment',
      name:   'payment',
      component:  () => import('../views/payment/payment')
    },

    // 财务管理
    { // 财务管理
      path:   '/reportExport',
      name:   'reportExport',
      component:  () => import('../views/reportExport')
    },

    // CBRE管家服务管理
    { // 服务管理
      path:   '/serviceMan',
      name:   'serviceMan',
      component:  () => import('../views/serviceMan')
    },
    { // 服务管理
      path:   '/serviceMan/:tab',
      component:  () => import('../views/serviceMan')
    },
    { // 服务订单
      path:   '/serviceOrderMan',
      name:   'serviceOrderMan',
      component:  () => import('../views/serviceOrderMan')
    },
    { // 商家订单管理
      path:   '/merchantOrderMan',
      name:   'merchantOrderMan',
      component:  () => import('../views/merchantOrderMan')
    },

    { // 财务管理
      path:   '/financeMan',
      name:   'financeMan',
      component:  () => import('../views/financeMan')
    },
    { // 财务管理
      path:   '/financeMan/:tab',
      component:  () => import('../views/financeMan')
    },
    { // 商家提现
      path:   '/settlementMan',
      name:   'settlementMan',
      component:  () => import('../views/settlementMan')
    },
    { // 社区服务费
      path:   '/serviceChargeMan',
      name:   'serviceChargeMan',
      component:  () => import('../views/serviceChargeMan')
    },

    // { // 停车场管理
    //   path:   '/parking',
    //   name:   'parking',
    //   component:  () => import('../views/parking')
    // },
    // { // 停车场管理
    //   path:   '/parking',
    //   name:   'parking',
    //   component:  () => import('../views/parking/parking.vue'),
    //   children: [
    //     // 订单管理
    //     { // 临保订单
    //       path:   'parking1',
    //       name:   'parking-parking1',
    //       component:  () => import('../views/parking/parking-1.vue')
    //     },
    //     { // 月保续费订单
    //       path:   'parking2',
    //       name:   'parking-parking2',
    //       component:  () => import('../views/parking/parking-2.vue')
    //     },
    //     { // 无牌车
    //       path:   'parking3',
    //       name:   'parking-parking3',
    //       component:  () => import('../views/parking/parking-2.vue')
    //     },
    //     // 优惠管理
    //     { // 券管理
    //       path:   'coupon',
    //       name:   'parking-coupon',
    //       component:  () => import('../views/parking/parking-coupon.vue'),
    //     },
    //     { // 有价券订单
    //       path:   'couponOrder',
    //       name:   'parking-couponOrder',
    //       component:  () => import('../views/parking/parking-couponOrder.vue'),
    //     },
    //     { // 0元券订单
    //       path:   'couponZero',
    //       name:   'parking-couponZero',
    //       component:  () => import('../views/parking/parking-couponZero.vue'),
    //     },
    //     { // 发券记录
    //       path:   'couponRecord',
    //       name:   'parking-couponRecord',
    //       component:  () => import('../views/parking/parking-couponRecord.vue'),
    //     },
    //     { // 商家管理
    //       path:   'merchant',
    //       name:   'parking-merchant',
    //       component:  () => import('../views/parking/parking-merchant.vue'),
    //     },
    //     // 数据管理
    //     { // 订单流水数据
    //       path:   'parkingReport',
    //       name:   'parking-parkingReport',
    //       component:  () => import('../views/parking/parking-report.vue'),
    //     },
    //     { // POMP账号
    //       path:   'pompUser',
    //       name:   'parking-pompUser',
    //       component:  () => import('../views/parking/parking-pompUser.vue'),
    //     },
    //   ]
    // },
    // { // 停车场管理
    //   path:   '/parking/:tab',
    //   component:  () => import('../views/parking')
    // },

    { // 业务办理（门禁卡办理）
      path:   '/bizApply',
      component:  () => import('../views/bizApply')
    },

    { // 数据配对
      path:   '/dataMatch',
      component:  () => import('../views/dataMatch')
    },

    { // 积分兑换
      path:   '/bonusPointExchange',
      name:   'bonusPointExchange',
      component:  () => import('../views/bonusPointExchange')
    },
    { // 积分发放
      path:   '/bonusPointGrant',
      name:   'bonusPointGrant',
      component:  () => import('../views/bonusPointGrant')
    },
    { // 积分行为
      path:   '/bonusPointMan',
      name:   'bonusPointMan',
      component:  () => import('../views/bonusPointMan')
    },

    { // 数据后台入口
      path:   '/stats',
      name:   'stats',
      component:  () => import('../views/stats')
    },

    { // 房间管理
      path:   '/roomInfo',
      name:   'roomInfo',
      component:  () => import('../views/roomInfo')
    },

    { // 收楼管理
      path:   '/repossession',
      name:   'repossession',
      component:  () => import('../views/repossession')
    },

    /*********************/

    { // 活动基本配置
      path:   '/activity-conf',
      name:   'activity-conf',
      component:  () => import('../views/activity-conf')
    },
    { // 活动奖品配置
      path:   '/activity-prize',
      name:   'activity-prize',
      component:  () => import('../views/activity-prize')
    },
    { // 中奖用户管理
      path:   '/activity-users',
      name:   'activity-users',
      component:  () => import('../views/activity-users')
    },
    { // 活动数据报表
      path:   '/activity-stats',
      name:   'activity-stats',
      component:  () => import('../views/activity-stats')
    },

    /*********************/

    { // 用户反馈
      path:   '/userFeedback',
      name:   'userFeedback',
      component:   () => import('../views/userFeedback')
    },

    /*********************/

    { // 小富市集 综合服务费订单
      path:   '/generalServiceOrder',
      name:   'generalServiceOrder',
      component:  () => import('../views/generalServiceOrder')
    },

    /*********************/

    { // 小富市集
      path:   '/rfFair',
      name:   'rfFair',
      component:  () => import('../views/rfFair')
    },

    { // 小富市集商家管理
      path:   '/rfFairMerchant',
      name:   'rfFairMerchant',
      component:  () => import('../views/rfFairMerchant')
    },

    { // 小富市集商家审批 平台
      path:   '/xfsjMerchantAuditPlatform',
      name:   'xfsjMerchantAuditPlatform',
      component:  () => import('../views/merchantApprovalPlatform')
    },
    { // 小富市集商家审批 物业
      path:   '/xfsjMerchantAuditWuye',
      name:   'xfsjMerchantAuditWuye',
      component:  () => import('../views/merchantApprovalProperty')
    },
    { // 小富市集商家审批 地区
      path:   '/xfsjMerchantAuditArea',
      name:   'xfsjMerchantAuditArea',
      component:  () => import('../views/merchantApprovalArea')
    },
    { // 角色管理
      path:   '/supervision',
      name:   'supervision',
      component:  () => import('../views/supervision')
    },

    /*********************/

    { // 参数配置
      path:   '/webAppConf',
      name:   'webAppConf',
      component:  () => import('../views/webAppConf')
    },

    { // POMP 系统跳板
      path:   '/pompGateway',
      name:   'pompGateway',
      component:  () => import('../views/pompGateway')
    },

    /*********************/

    { // 常规测试
      path:   '/opyt',
      component:  () => import('../views/opyt')
    },
    /*********************/
    { // 平台卡券管理
      path:   '/couponOperator',
      name:   'couponOperator',
      component:  () => import('../views/coupon/couponOperator.vue')
    },
    { // 平台卡券管理详情
      path:   '/couponOperator/:couponId',
      name:   'couponOperatorDetail',
      component:  () => import('../views/coupon/couponOperatorDetail.vue')
    },
    { // 商家卡券管理
      path:   '/couponMerchant',
      name:   'couponMerchant',
      component:  () => import('../views/coupon/couponMerchant.vue')
    },
    { // 商家卡券管理详情
      path:   '/couponMerchant/:couponId',
      name:   'couponMerchantDetail',
      component:  () => import('../views/coupon/couponMerchantDetail.vue')
    },
    /*********************/

    { // cbre的问答，author:snoob
      path:   '/faq',
      name:   'faq',
      component:  () => import('../views/faq')
    },

    { // 停车场管理
      path:   '/parking',
      name:   'parkingtest',
      redirect: { path: '/operation/parking/parking1' },
      // component:  () => import('../views/main/operation/parking/parking.vue')
    },

    { // 业务运营
      path: '/operation',
      name: 'operation',
      meta: {
        aliasName: '10003'
      },
      component: () => import('../components/Container.vue'),
      children: [
        { // 新停车场管理
          path: 'parking',
          name: 'parking',
          component: () => import('../views/main/operation/parking/parking.vue'),
          children: [
            // 订单管理
            { // 临保订单
              path: 'parking1',
              name: 'parking-parking1',
              component: () => import('../views/main/operation/parking/parking-1.vue')
            },
            { // 月保续费订单
              path: 'parking2',
              name: 'parking-parking2',
              component: () => import('../views/main/operation/parking/parking-2.vue')
            },
            { // 月保续费订单
              path: 'parking2-approve',
              name: 'parking-parking2-approve',
              component: () => import('../views/main/operation/parking/parking2-approve.vue')
            },
            { // 无牌车
              path: 'parking3',
              name: 'parking-parking3',
              component: () => import('../views/main/operation/parking/parking-3.vue')
            },
            { // 固定无牌车
              path: 'parking3-regular',
              name: 'parking-parking3-regular',
              component: () => import('../views/main/operation/parking/parking3-regular.vue')
            },
            { // 线下订单
              path: 'parking4',
              name: 'parking-parking4',
              component: () => import('../views/main/operation/parking/parking-4.vue')
            },
            // 优惠管理
            { // 券管理
              path: 'coupon',
              name: 'parking-coupon',
              component: () => import('../views/main/operation/parking/parking-coupon.vue'),
            },
            { // 有价券订单
              path: 'couponOrder',
              name: 'parking-couponOrder',
              component: () => import('../views/main/operation/parking/parking-couponOrder.vue'),
            },
            { // 0元券订单
              path: 'couponZero',
              name: 'parking-couponZero',
              component: () => import('../views/main/operation/parking/parking-couponZero.vue'),
            },
            { // 发券记录
              path: 'couponRecord',
              name: 'parking-couponRecord',
              component: () => import('../views/main/operation/parking/parking-couponRecord.vue'),
            },
            { // 商家管理
              path: 'merchant',
              name: 'parking-merchant',
              component: () => import('../views/main/operation/parking/parking-merchant.vue'),
            },
            // 数据管理
            { // 订单流水数据
              path: 'parkingReport',
              name: 'parking-parkingReport',
              component: () => import('../views/main/operation/parking/parking-report.vue'),
            },
            { // 车位数据
              path: 'carportData',
              name: 'parking-carportData',
              component: () => import('../views/main/operation/parking/parking-carportData.vue'),
            },
            { // 商家券数据
              path: 'couponData',
              name: 'parking-couponData',
              component: () => import('../views/main/operation/parking/parking-couponData.vue'),
            },
            { // 商家券数据
              path: 'priceTable',
              name: 'parking-priceTable',
              component: () => import('../views/main/operation/parking/parking-priceTable.vue'),
            },
            { // POMP账号
              path: 'pompUser',
              name: 'parking-pompUser',
              component: () => import('../views/main/operation/parking/parking-pompUser.vue'),
            },
            // 充电桩
            { // 买卡订单
              path: 'cardRecord',
              name: 'parking-cardRecord',
              component: () => import('../views/main/operation/parking/parking-cardRecord.vue'),
            },
            { // 用电记录
              path: 'chargeRecord',
              name: 'parking-chargeRecord',
              component: () => import('../views/main/operation/parking/parking-chargeRecord.vue'),
            },
            // 锁车管理
            { // 开通锁车用户
              path: 'lockerUser',
              name: 'parking-lockerUser',
              component: () => import('../views/main/operation/parking/parking-lockerUser.vue'),
            },
            { // 锁车/解锁管理与记录
              path: 'lockerRecord',
              name: 'parking-lockerRecord',
              component: () => import('../views/main/operation/parking/parking-lockerRecord.vue'),
            }
          ]
        },
      ]
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js